import script from "./HighlightTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightTextArea.vue?vue&type=script&setup=true&lang=js"

import "./HighlightTextArea.vue?vue&type=style&index=0&id=3c2bb815&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c2bb815"]])

export default __exports__